export enum Rubric {
  VERYBAD = 'very-bad',
  BAD = 'bad',
  GOOD = 'good',
  EXCELLENT = 'excellent'
}

export type RubricType = `${Rubric}`;
